import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPitch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 461,
	height: 383,
	viewBox: "0 0 461 383",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M368.11 0.5C379.887 0.5 389.998 8.8786 392.185 20.4502L455.113 353.45C457.964 368.538 446.395 382.5 431.04 382.5H28.96C13.6055 382.5 2.03554 368.538 4.88672 353.45L67.8154 20.4502C70.0024 8.87861 80.1132 0.5 91.8896 0.5H368.11Z",
			stroke: "url(#paint0_linear_2103_39)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -.0471191,
			y: -4,
			width: 460.094,
			height: 391,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(2.5px)",
					clipPath: "url(#bgblur_0_2103_39_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_n_2103_39)",
			"data-figma-bg-blur-radius": 5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M68.3067 20.5435C70.4489 9.20782 80.3531 1 91.8894 1H368.111C379.647 1 389.551 9.20781 391.693 20.5434L454.622 353.543C457.415 368.323 446.081 382 431.04 382H28.9602C13.919 382 2.58461 368.323 5.37762 353.543L68.3067 20.5435Z",
				fill: "#262626",
				fillOpacity: .8
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .8,
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask0_2103_39",
				style: { maskType: "alpha" },
				maskUnits: "userSpaceOnUse",
				x: 5,
				y: 0,
				width: 451,
				height: 382,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M68.8143 19.5547C70.9519 8.21378 80.8584 0 92.399 0H368.601C380.142 0 390.048 8.21381 392.186 19.5547L455.139 353.555C457.924 368.331 446.59 382 431.554 382H29.4461C14.4096 382 3.07634 368.331 5.86142 353.555L68.8143 19.5547Z",
					fill: "#262626",
					fillOpacity: .7
				})
			}), /* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_2103_39)",
				children: /* @__PURE__ */ _jsxs("g", {
					filter: "url(#filter1_f_2103_39)",
					children: [
						/* @__PURE__ */ _jsx("ellipse", {
							cx: 66,
							cy: 215.5,
							rx: 89.5,
							ry: 109.5,
							fill: "#259838"
						}),
						/* @__PURE__ */ _jsx("ellipse", {
							cx: 122,
							cy: 50.5,
							rx: 64.5,
							ry: 63.5,
							fill: "#0370F1"
						}),
						/* @__PURE__ */ _jsx("circle", {
							cx: 442,
							cy: 172,
							r: 89.5,
							fill: "#40CF18"
						}),
						/* @__PURE__ */ _jsx("ellipse", {
							cx: 187,
							cy: 342.5,
							rx: 178.5,
							ry: 51.5,
							fill: "#F8E11E"
						})
					]
				})
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195 280C195 267.85 210.67 258 230 258C249.33 258 265 267.85 265 280",
			stroke: "white",
			strokeOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M355.5 382L343.233 286.976C342.718 282.987 339.321 280 335.299 280H124.701C120.679 280 117.282 282.987 116.767 286.976L104.5 382",
			stroke: "white",
			strokeOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M296.5 382L291.036 326.22C290.635 322.123 287.19 319 283.074 319H174.926C170.81 319 167.365 322.123 166.964 326.22L161.5 382",
			stroke: "white",
			strokeOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M264.5 0C264.5 16.0163 248.83 29 229.5 29C210.17 29 194.5 16.0163 194.5 0",
			stroke: "white",
			strokeOpacity: .2
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_n_2103_39",
				x: -.0471191,
				y: -4,
				width: 460.094,
				height: 391,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feTurbulence", {
						type: "fractalNoise",
						baseFrequency: "1.4285714626312256 1.4285714626312256",
						stitchTiles: "stitch",
						numOctaves: 3,
						result: "noise",
						seed: 660
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "noise",
						type: "luminanceToAlpha",
						result: "alphaNoise"
					}),
					/* @__PURE__ */ _jsx("feComponentTransfer", {
						in: "alphaNoise",
						result: "coloredNoise1",
						children: /* @__PURE__ */ _jsx("feFuncA", {
							type: "discrete",
							tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
						})
					}),
					/* @__PURE__ */ _jsx("feComposite", {
						operator: "in",
						in2: "shape",
						in: "coloredNoise1",
						result: "noise1Clipped"
					}),
					/* @__PURE__ */ _jsx("feFlood", {
						floodColor: "rgba(36, 165, 0, 0.15)",
						result: "color1Flood"
					}),
					/* @__PURE__ */ _jsx("feComposite", {
						operator: "in",
						in2: "noise1Clipped",
						in: "color1Flood",
						result: "color1"
					}),
					/* @__PURE__ */ _jsxs("feMerge", {
						result: "effect1_noise_2103_39",
						children: [/* @__PURE__ */ _jsx("feMergeNode", { in: "shape" }), /* @__PURE__ */ _jsx("feMergeNode", { in: "color1" })]
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_2103_39_clip_path",
				transform: "translate(0.0471191 4)",
				children: /* @__PURE__ */ _jsx("path", { d: "M68.3067 20.5435C70.4489 9.20782 80.3531 1 91.8894 1H368.111C379.647 1 389.551 9.20781 391.693 20.5434L454.622 353.543C457.415 368.323 446.081 382 431.04 382H28.9602C13.919 382 2.58461 368.323 5.37762 353.543L68.3067 20.5435Z" })
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_f_2103_39",
				x: -227.5,
				y: -217,
				width: 963,
				height: 815,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 102,
						result: "effect1_foregroundBlur_2103_39"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_2103_39",
				x1: 80,
				y1: 7,
				x2: 422.5,
				y2: 384.5,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#006AFF" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .308243,
						stopColor: "#2FD900"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .667422,
						stopColor: "#FFED4E"
					})
				]
			})
		] })
	]
});
export default SvgPitch;
